import { ProductType } from '@/models/ad';

const DURATION_15S = 15;
const DURATION_30S = 30;

export const getUploadUrlByProductType = (
  url: string,
  productType: ProductType
) => {
  if (productType === ProductType.Video15s) {
    return `${url}?videoDuration=${DURATION_15S}`;
  }
  if (productType === ProductType.Video30s) {
    return `${url}?videoDuration=${DURATION_30S}`;
  }
  return url;
};

export const convertToBlob = (
  file: File,
  type: 'image' | 'video'
): Promise<Blob> => {
  return new Promise<Blob>((resolve, reject) => {
    const blob = new Blob([file], {
      type: type === 'image' ? 'image/*' : 'video/*',
    });

    if (blob) {
      resolve(blob);
    } else {
      reject(new Error('Failed to convert file to blob'));
    }
  });
};

export const getFileType = (file: File) => {
  let fileType: 'image' | 'video' | null = null;

  if (file.type.startsWith('image/')) {
    fileType = 'image';
  }

  if (file.type.startsWith('video/')) {
    fileType = 'video';
  }

  return fileType;
};

export const generatePreviewURL = async (file: File) => {
  const fileType = getFileType(file);

  if (fileType) {
    const blob = await convertToBlob(file, fileType);
    return URL.createObjectURL(blob);
  }

  return null;
};
